import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "form"];

  connect() {
    console.log("ModalNewEventController connected");
  }

  open() {
    console.log("ModalNewEventController open");
    this.modalTarget.style.display = "block";
  }

  close() {
    this.modalTarget.style.display = "none";
  }

  submit() {
    this.formTarget.submit();
    this.close();
  }
}
